import request from '../request';

/** 关注 / 取消关注 */
export async function setCollect(params: API.UserAttentionReq) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/member/user/attention/createOrCancel',
    method: 'POST',
    data: params,
    headers: { authLogin: true },
  });
}

/** 关注商品列表 */
export async function getCollectList(params: API.PageInfo) {
  return request<API.CommonPageInfoResponse<API.UserAttentionProductInfoVO[]>>({
    url: '/api/mall/rest/member/user/attention/queryPage',
    method: 'POST',
    data: params,
  });
}
